import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import ScrollToTop from './components/ScrollToTop';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Pages
import Home from './pages/Home';
import Consulting from './pages/Consulting';
import MechanicalEngineering from './pages/MechanicalEngineering';
import ElectricalEngineering from './pages/ElectricalEngineering';
import CADDesignFEM from './pages/CADDesignFEM';
import AssemblyCommissioning from './pages/AssemblyCommissioning';
import DocumentationCE from './pages/DocumentationCE';
import Automation from './pages/Automation';
import AutomaticMachines from './pages/AutomaticMachines';
import RobotProgramming from './pages/RobotProgramming';
import PLCSCADA from './pages/PLCSCADA';
import ProblemSolving from './pages/ProblemSolving';
import CompleteSolutions from './pages/CompleteSolutions';
import ProductionEquipment from './pages/ProductionEquipment';
import Tooling from './pages/Tooling';
import Projects from './pages/Projects';
import About from './pages/About';
import BicycleService from './pages/BicycleService';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import Forbidden from './pages/Forbidden';

export default function App() {
  return (
    <HelmetProvider>
      <div className="flex flex-col min-h-screen bg-[#0b1017] text-slate-100 font-sans antialiased selection:bg-cyan-500/20 selection:text-cyan-300">
        <ScrollToTop />
        <Navbar />

        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/konsulentydelser" element={<Consulting />} />
            
            {/* Konsulentydelser undersider */}
            <Route path="/ydelser/mekanisk-konstruktion" element={<MechanicalEngineering />} />
            <Route path="/mekanisk-konstruktion" element={<MechanicalEngineering />} />
            
            <Route path="/ydelser/elkonstruktion" element={<ElectricalEngineering />} />
            <Route path="/elkonstruktion" element={<ElectricalEngineering />} />

            <Route path="/ydelser/cad-fem" element={<CADDesignFEM />} />
            <Route path="/cad-fem" element={<CADDesignFEM />} />

            <Route path="/ydelser/montage-indkoring" element={<AssemblyCommissioning />} />
            <Route path="/montage-indkoring" element={<AssemblyCommissioning />} />

            <Route path="/ydelser/dokumentation-ce" element={<DocumentationCE />} />
            <Route path="/dokumentation-ce" element={<DocumentationCE />} />

            {/* Automation & undersider */}
            <Route path="/automation" element={<Automation />} />
            <Route path="/automation/automatiske-maskiner" element={<AutomaticMachines />} />
            <Route path="/automatiske-maskiner" element={<AutomaticMachines />} />
            
            <Route path="/automation/robot-programmering" element={<RobotProgramming />} />
            <Route path="/robot-programmering" element={<RobotProgramming />} />

            <Route path="/automation/plc-scada" element={<PLCSCADA />} />
            <Route path="/plc-scada" element={<PLCSCADA />} />

            <Route path="/problemlosninger" element={<ProblemSolving />} />
            <Route path="/automation/problemlosninger" element={<ProblemSolving />} />

            {/* Komplette løsninger */}
            <Route path="/komplette-losninger" element={<CompleteSolutions />} />

            {/* Produktionsudstyr & Værktøj */}
            <Route path="/produktionsudstyr" element={<ProductionEquipment />} />
            <Route path="/vaerktoj" element={<Tooling />} />

            {/* Projekter & Referencer */}
            <Route path="/projekter" element={<Projects />} />
            <Route path="/referencer" element={<Projects />} />

            {/* Om JARCon */}
            <Route path="/om-mig" element={<About />} />
            <Route path="/om-jarcon" element={<About />} />

            {/* Cykelservice */}
            <Route path="/cykelservice" element={<BicycleService />} />

            {/* Kontakt */}
            <Route path="/kontakt" element={<Contact />} />

            {/* Fejlsider */}
            <Route path="/403" element={<Forbidden />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </HelmetProvider>
  );
}
